import { useAuthentication } from 'authentication'
import { useTranslation } from 'react-i18n-lite'
import apiAsync from '../../utils/api-async'
import { defaultLanguage } from './I18n'
import { useQuery } from './useQuery'

export function RedirectToLogin() {
  const { language } = useTranslation()
  const query = useQuery()

  const { token: tokenInState } = useAuthentication()
  const tokenInQuery = query.get('token')
  const tokenInLocalStorage = localStorage.getItem('token')

  const token = tokenInState || tokenInQuery || tokenInLocalStorage

  apiAsync.setAuthToken(token)

  if (!token) {
    window.location = `${window.waAuthenticationUrl}login?redirectOrigin=${
      window.location.href
    }&lang=${language || defaultLanguage}`
  }

  return null
}

export default RedirectToLogin
